import React from 'react';
import { Typography, Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
    btnSave: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 6,
        paddingBottom: 6
    },
});

function LoadingButton({ loading, label, onClick }) {
    const classes = useStyles();

    return (
        <Button
            disabled={loading}
            className={classes.button}
            variant="contained"
            color="primary"
            onClick={onClick}
        >
            {
                loading ? <CircularProgress size={24} /> : <Typography className={classes.btnSave}>{label}</Typography>
            }
        </Button>
    )
}

LoadingButton.propTypes = {
    label: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default LoadingButton;
